import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import translationEN from './locales/translation.en.json';
import translationFR from './locales/translation.fr.json';
import translationES from './locales/translation.es.json';
// import * as moment from 'moment';
// import 'moment/locale/fr';
// import 'moment/locale/es';

const getLanguagePreference = () => {
	function getCookieByName(name) {
		const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		return match ? decodeURIComponent(match[2]) : null;
	}
	// Get the value of 'paycorCulture' or default to 'en'
	return getCookieByName('paycorCulture') || 'en';
};

const resources = {
	en: {
		translation: translationEN
	},
	fr: {
		translation: translationFR
	},
	es: {
		translation: translationES
	}
};

i18n
	.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources,
		debug: false,
		ns: ['translation'],
		lng: getLanguagePreference(),
		fallbackLng: 'en',
		keySeparator: '.',
		interpolation: {
			escapeValue: false,
			formatSeparator: ','
		}
	});

// moment.locale(getLanguagePreference());

const translateConstant = (constantValue, t) => {
	const key = Object.keys(translationEN).find((k) => translationEN[k] === constantValue);
	if (key) {
		return t(`${key}`);
	}
	return constantValue;
};

const translateDateConstant = () => {
	switch (getLanguagePreference()) {
		case 'fr':
			return 'JJ/MM/AAAA';
		case 'es':
			return 'DD/MM/AAAA';
		default:
			return 'MM/DD/YYYY';
	}
};

export { i18n, translateConstant, translateDateConstant };
